import { render } from "./Headers.vue?vue&type=template&id=855400de"
const script = {}

const cssModules = {}
import style0 from "./Headers.vue?vue&type=style&index=0&id=855400de&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__